// extracted by mini-css-extract-plugin
export default {"MoreInfo":"SDGBreakdown_MoreInfo__Xukr0","Description":"SDGBreakdown_Description__a15gE"};